import React from 'react';

function PlusSmallSVG() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <rect x="6.10352e-05" width="20" height="20" rx="4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 5C10.5523 5 11.0001 5.44772 11.0001 6V9H14.0001C14.5523 9 15.0001 9.44772 15.0001 10C15.0001 10.5523 14.5523 11 14.0001 11H11.0001V14C11.0001 14.5523 10.5523 15 10.0001 15C9.44778 15 9.00006 14.5523 9.00006 14V11H6.00006C5.44778 11 5.00006 10.5523 5.00006 10C5.00006 9.44772 5.44778 9 6.00006 9H9.00006V6C9.00006 5.44772 9.44778 5 10.0001 5Z"
        fill="#969FA8"
      />
    </svg>
  );
}

export default PlusSmallSVG;
